import "../Styling/Hero.css"
import { Link } from 'react-router-dom'

export default function Hero({ t }) {
    return (<div className="hero-container">

<div className="hero-background md:parallax-one grid md:flex gap-[10px] grid-rows-[max-content,max-content] items-start md:items-center">

            <span className="hero-logo h-auto"></span>
            <h2>{t.heroTitle}</h2>
        </div>
        <div className="hero-button grid gap-0 lg:flex lg:gap-20 content-center justify-center">
            <h6 className="text-white text-center text-sm sm:text-xl md:text-2xl max-w-[80vw] lg:max-w-[60vw] justify-self-center">{t.contactSecondTitle}</h6>
            <Link to="/contact" className="bg-[--c-accent] hover:bg-[--c-dark-accent] w-[280px] justify-self-center sm:w-auto transition-all duration-300 rounded-lg shadow-lg hover:shadow-xl h-auto">{t.button}</Link>
        </div>
    </div>)
}